// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"bfa64927","128":"3e3bfd88","158":"d75b4fbf","453":"72370b05"}[chunkId] + ".chunk.js";
};